import * as $ from 'jquery';
import { ScrollLock } from './helpers/scrollLock';

export class Modal {
    constructor(selector: string) {
        this.selector = selector;
    }

    private cssClass = 'modal';
    private showCssClass = this.cssClass + '--open';
    private windowCssClass = this.cssClass + '__window';
    private closeButtonCssClass = 'js-closemodal';

    private readonly selector: string;
    private $modal: any;
    private $closeButton: any;
    private $modalWindow: any;

    private stopPropagation(event): void {
        event.stopPropagation();
    }

    private createModal(): void {
        if (!this.$modal) {
            this.$modal = $(this.selector);
            this.$modal.find(`.${this.closeButtonCssClass}`).on('click', (event) => this.close(event));
            this.$modal.find(`.${this.windowCssClass}`).on('click', this.stopPropagation);
        }
    }

    show(): void {
        this.createModal();

        ScrollLock.lock();
        this.$modal.addClass(this.showCssClass);
    }

    close(event?): void {
        if (event) {
            event.preventDefault();
        }

        ScrollLock.unlock();
        this.$modal.removeClass(this.showCssClass);
    }

    getReference(): JQuery {
        this.createModal();
        return this.$modal;
    }

    getSelector(): string {
        return this.selector;
    }
}
